import { createContext } from "react";

export const ContextoToken = createContext();
ContextoToken.displayName = "ContextoToken";
